import React, { useState, useRef } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Popover,
  TextField,
} from "@material-ui/core";
import ExtjsRowTemplatePanel from "./ExtjsRowTemplatePanel";
import styled from "styled-components";
import { observer } from "mobx-react";

function EmailTemplatePopup({
  store,
  anchorEl,
  handleClose,
  criteria,
  columns,
  handleChange,
  templateBody,
  attatchmentData,
  ...props
}) {
  const extjsRowTemplatePanel = useRef(null);
  const [subject, setSubject] = React.useState(props.subject);

  const handleSave = () => {
    const mailBody = extjsRowTemplatePanel.current.cmp.getTemplateValue();
    const mailAttatchmentsData = extjsRowTemplatePanel.current.cmp.getTemplateAttachment();

    handleChange(mailBody, mailAttatchmentsData, subject);
    handleClose();
  };

  React.useEffect(() => {
    setSubject(props.subject);
  }, [props.subject]);

  return (
    <Popover
      anchorReference="anchorPosition"
      anchorPosition={{ top: 0, left: 999999 }}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      // onClose={handleClose}
      PaperProps={{
        style: {
          // maxWidth: 500,
          // minWidth: 400
          width: 950,
        },
      }}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        Edit Template
      </DialogTitle>
      <StyledDialogContent>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              label="Subject"
              variant="outlined"
              value={subject}
              style={{ width: 400 }}
              onChange={(e) => setSubject(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <ExtjsRowTemplatePanel
              ref={extjsRowTemplatePanel}
              list={store.list}
              templateBody={templateBody}
              attatchmentData={attatchmentData}
              columns={store.list.columns}
              // lookupListId={currentLisId}
              delayedRender
            />
          </Grid>
        </Grid>
      </StyledDialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Popover>
  );
}

export default observer(EmailTemplatePopup);

const StyledDialogContent = styled(DialogContent)`
  max-height: 74vh;
`;